import type {z} from "zod";
import type {expedientOffersRouteApi} from "./-route-api";
import {listCustomerOffersSearchSchema} from "@project/application/sales/customer-offers";

export const expedientOffersSearchSchema = listCustomerOffersSearchSchema
  .omit({expedientId: true})
  .extend({
    latestOnly: listCustomerOffersSearchSchema.shape.latestOnly.transform(() => true as const),
  });
export const expedientOfferFiltersSchema = expedientOffersSearchSchema
  .pick({
    status: true,
    offerOrdinal: true,
    version: true,
    q: true,
    statuses: true,
    language: true,
    currencyCode: true,
  })
  .extend({
    status: expedientOffersSearchSchema.shape.status.removeCatch(),
    offerOrdinal: expedientOffersSearchSchema.shape.offerOrdinal.removeCatch(),
    version: expedientOffersSearchSchema.shape.version.removeCatch(),
    statuses: expedientOffersSearchSchema.shape.statuses.removeCatch(),
    language: expedientOffersSearchSchema.shape.language.removeCatch(),
    currencyCode: expedientOffersSearchSchema.shape.currencyCode.removeCatch(),
  })
  .strict();
export type ExpedientOffersSearch = z.output<typeof expedientOffersSearchSchema>;
export type ExpedientOfferFilters = z.output<typeof expedientOfferFiltersSchema>;
export type ExpedientOffersNavigateFn = ReturnType<typeof expedientOffersRouteApi.useNavigate>;
